"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_DROPDOWN_DATA = exports.SET_DROPDOWN_DATA = "SET_DROPDOWN_DATA";
var EMPLOYEE_FETCH_SUCCESS = exports.EMPLOYEE_FETCH_SUCCESS = "EMPLOYEE_FETCH_SUCCESS";
var EMPLOYEE_FETCH_ERROR = exports.EMPLOYEE_FETCH_ERROR = "EMPLOYEE_FETCH_ERROR";
var EMPLOYEE_TO_ASSIGN_FETCH_SUCCESS = exports.EMPLOYEE_TO_ASSIGN_FETCH_SUCCESS = "EMPLOYEE_TO_ASSIGN_FETCH_SUCCESS";
var EMPLOYEE_TO_ASSIGN_FETCH_PENDING = exports.EMPLOYEE_TO_ASSIGN_FETCH_PENDING = "EMPLOYEE_TO_ASSIGN_FETCH_PENDING";
var EMPLOYEE_TO_ASSIGN_FETCH_ERROR = exports.EMPLOYEE_TO_ASSIGN_FETCH_ERROR = "EMPLOYEE_TO_ASSIGN_FETCH_ERROR";
var EMPLOYEE_FETCH_PENDING = exports.EMPLOYEE_FETCH_PENDING = "EMPLOYEE_FETCH_PENDING";
var CITIZEN_FETCH_SUCCESS = exports.CITIZEN_FETCH_SUCCESS = "CITIZEN_FETCH_SUCCESS";
var CITIZEN_FETCH_ERROR = exports.CITIZEN_FETCH_ERROR = "CITIZEN_FETCH_ERROR";
var MDMS_FETCH_SUCCESS = exports.MDMS_FETCH_SUCCESS = "MDMS_FETCH_SUCCESS";
var MDMS_FETCH_ERROR = exports.MDMS_FETCH_ERROR = "MDMS_FETCH_ERROR";
var PREPARE_FORM_DATA = exports.PREPARE_FORM_DATA = "PREPARE_FORM_DATA";
var GENERAL_MDMS_FETCH_SUCCESS = exports.GENERAL_MDMS_FETCH_SUCCESS = "GENERAL_MDMS_FETCH_SUCCESS";
var GENERAL_MDMS_FETCH_ERROR = exports.GENERAL_MDMS_FETCH_ERROR = "GENERAL_MDMS_FETCH_ERROR";
var TOGGLE_SPINNER = exports.TOGGLE_SPINNER = "TOGGLE_SPINNER";
var SHOW_SPINNER = exports.SHOW_SPINNER = "SHOW_SPINNER";
var HIDE_SPINNER = exports.HIDE_SPINNER = "HIDE_SPINNER";

var PREPARE_FORM_DATA_FROM_DRAFT = exports.PREPARE_FORM_DATA_FROM_DRAFT = "PREPARE_FORM_DATA_FROM_DRAFT";
var FETCH_PGR_CONSTANTS = exports.FETCH_PGR_CONSTANTS = "FETCH_PGR_CONSTANTS";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/common/actionTypes.js
// module id = ../lib/egov-ui-kit/redux/common/actionTypes.js
// module chunks = 504